import type { OtpChallenge } from "../types/api";

const OTP_CHALLENGE_KEY = "mira.helpdesk.otp";

/**
 * Mantém o desafio de verificação entre a tela de login e a de código,
 * inclusive se o usuário atualizar a página. Vive apenas na aba atual.
 */
export function rememberOtpChallenge(challenge: OtpChallenge) {
  try {
    window.sessionStorage.setItem(OTP_CHALLENGE_KEY, JSON.stringify(challenge));
  } catch {
    // Sem armazenamento a verificação segue válida somente na navegação atual.
  }
}

export function getOtpChallenge(): OtpChallenge | null {
  try {
    const value = window.sessionStorage.getItem(OTP_CHALLENGE_KEY);
    if (!value) return null;
    const challenge = JSON.parse(value) as OtpChallenge;
    return challenge.desafio ? challenge : null;
  } catch {
    return null;
  }
}

export function clearOtpChallenge() {
  try {
    window.sessionStorage.removeItem(OTP_CHALLENGE_KEY);
  } catch {
    // Nada a limpar quando o armazenamento está indisponível.
  }
}
